<div class="alerts-container">

  <!-- Page Header -->
  <div class="page-header">
    <div class="header-title">
      <p class="page-title">Avvisi</p>
      <div class="header-bar"></div>
    </div>

    <!-- Admin: FamilyTutor multi-select -->
    <div class="operator-selector" *ngIf="isAdmin">
      <span class="operator-label">
      FamilyTutor:
      </span>
      <div class="operator-chips">
        <label
          class="operator-chip"
          *ngFor="let op of operators"
          [class.active]="isSelected(op.value)"
        >
          <input
            type="checkbox"
            [checked]="isSelected(op.value)"
            (change)="toggleOperator(op.value)"
          />
          {{ op.label }}
        </label>
      </div>
    </div>
  </div>

  <!-- Tabs -->
  <div class="tab-bar">
    <button type="button" class="tab-btn" [class.active]="activeTab === 'selezione'"
      (click)="switchTab('selezione')">Selezione</button>
    <button type="button" class="tab-btn" [class.active]="activeTab === 'servizio'"
      (click)="switchTab('servizio')">Servizio</button>
    <button type="button" class="tab-btn" [class.active]="activeTab === 'longevity'"
      (click)="switchTab('longevity')">Longevity</button>
  </div>

  <!-- ═══════════════════════ TAB SELEZIONE ═══════════════════════ -->
  <ng-container *ngIf="activeTab === 'selezione'">

    <!-- Eccezioni switch -->
    <div class="eccezioni-switch" *ngIf="selectedOperators.length > 0">
      <label class="switch-label">
        <input type="checkbox" [checked]="eccezioniOnly" (change)="toggleEccezioni()" />
        <span>Mostra solo Eccezioni (oltre i giorni limite)</span>
      </label>
    </div>

    <!-- Loading state -->
    <div class="state-message" *ngIf="isLoading">
      <i class="bi bi-hourglass-split" style="font-size: 40px; opacity: 0.35;"></i>
      <span>Caricamento avvisi in corso...</span>
    </div>

    <!-- Admin: no operator selected -->
    <div class="state-message" *ngIf="isAdmin && selectedOperators.length === 0 && !isLoading">
      <i class="bi bi-bell" style="font-size: 48px; opacity: 0.2;"></i>
      <p>Seleziona almeno un FamilyTutor per visualizzare gli avvisi.</p>
    </div>

    <!-- FamilyTutor: operator name not found -->
    <div class="state-message" *ngIf="!isAdmin && selectedOperators.length === 0 && !isLoading">
      <i class="bi bi-exclamation-triangle" style="font-size: 48px; color: #f59e0b; opacity: 0.5;"></i>
      <p>Impossibile caricare gli avvisi. Rieffettua il login.</p>
    </div>

    <!-- All clear -->
    <div class="state-message success-state" *ngIf="isContentReady && !hasAlerts">
      <i class="bi bi-check-circle-fill" style="font-size: 48px; color: #16a34a;"></i>
      <p>Nessun avviso presente. Tutto in ordine!</p>
    </div>

    <!-- Alert sections -->
    <ng-container *ngIf="isContentReady && hasAlerts">
      <div class="alert-section" *ngFor="let section of sections">

        <div class="section-header" [ngClass]="'status-' + section.statusKey">
          <div class="section-title">
            <i class="bi bi-exclamation-circle-fill"></i>
            <span>{{ section.title }}</span>
            <span class="threshold-badge" *ngIf="section.threshold">{{ section.threshold }}</span>
          </div>
          <span class="section-count">
            {{ section.requests.length }} {{ section.requests.length === 1 ? 'richiesta' : 'richieste' }}
          </span>
        </div>

        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>ID Richiesta</th>
                <th>Nome Cliente</th>
                <th *ngIf="showOperatorColumn">Operatore</th>
                <th>Servizio</th>
                <th>Tipo Cliente</th>
                <th>Azienda</th>
                <th>In Stato Da</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of section.requests" class="table-row">
                <td class="id-cell">
                  <a [href]="'/request-detail/' + r.id" target="_blank" class="id-link">#{{ r.id }}</a>
                </td>
                <td>{{ r.clientName || '-' }}</td>
                <td *ngIf="showOperatorColumn">{{ r.operator }}</td>
                <td><span class="service-badge">{{ r.service }}</span></td>
                <td>
                  <span class="customer-badge" [ngClass]="r.customerType === 'B2B' ? 'badge-b2b' : 'badge-b2c'">
                    {{ r.customerType }}
                  </span>
                </td>
                <td>{{ r.company || '-' }}</td>
                <td>
                  <span class="days-badge" [ngClass]="section.daysBadgeClass">
                    {{ r.daysInStatus }} {{ r.daysInStatus === 1 ? 'giorno' : 'giorni' }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </ng-container>

  </ng-container>

  <!-- ═══════════════════════ TAB SERVIZIO ═══════════════════════ -->
  <ng-container *ngIf="activeTab === 'servizio'">

    <!-- Info: funzionamento duplicazione eventi -->
    <div class="info-banner">
      <i class="bi bi-info-circle-fill"></i>
      <p>
        Il <strong>25 di ogni mese</strong>, per le richieste con <strong>Lavoro continuativo</strong> attivo, o con
        data di fine richiesta non ancora raggiunta, un'automazione duplica l'ultimo evento in stato "Pagato" o "Da
        pagare" e lo inserisce in questa pagina come nuovo evento <strong>Da Validare</strong>. Il FamilyTutor deve
        verificare (ed eventualmente
        correggere) ore effettuate e importo seduta prima di confermarlo: alla conferma viene generato il link di
        pagamento e l'evento passa in stato <strong>Da Pagare</strong>, da cui il FamilyTutor può copiare il link e
        inviarlo alla famiglia.
      </p>
    </div>

    <!-- Admin: no operator selected -->
    <div class="state-message" *ngIf="isAdmin && selectedOperators.length === 0 && !isLoadingService">
      <i class="bi bi-bell" style="font-size: 48px; opacity: 0.2;"></i>
      <p>Seleziona almeno un FamilyTutor per visualizzare gli eventi.</p>
    </div>

    <!-- FamilyTutor: operator name not found -->
    <div class="state-message" *ngIf="!isAdmin && selectedOperators.length === 0 && !isLoadingService">
      <i class="bi bi-exclamation-triangle" style="font-size: 48px; color: #f59e0b; opacity: 0.5;"></i>
      <p>Impossibile caricare gli eventi. Rieffettua il login.</p>
    </div>

    <!-- Loading state -->
    <div class="state-message" *ngIf="isLoadingService">
      <i class="bi bi-hourglass-split" style="font-size: 40px; opacity: 0.35;"></i>
      <span>Caricamento eventi in corso...</span>
    </div>

    <ng-container *ngIf="selectedOperators.length > 0 && !isLoadingService">

      <!-- All clear -->
      <div class="state-message success-state" *ngIf="!hasServiceEvents">
        <i class="bi bi-check-circle-fill" style="font-size: 48px; color: #16a34a;"></i>
        <p>Nessun evento da validare o da pagare.</p>
      </div>

      <!-- Da Validare -->
      <div class="alert-section" *ngIf="pendingEvents.length > 0">
        <div class="section-header status-da-validare">
          <div class="section-title">
            <i class="bi bi-exclamation-circle-fill"></i>
            <span>Da Validare</span>
          </div>
          <span class="section-count">
            {{ pendingEvents.length }} {{ pendingEvents.length === 1 ? 'evento' : 'eventi' }}
          </span>
        </div>

        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>ID Richiesta</th>
                <th>Nome Cliente</th>
                <th *ngIf="showOperatorColumn">Operatore</th>
                <th>Servizio</th>
                <th>Tipo Cliente</th>
                <th>Data Inizio</th>
                <th>Data Fine</th>
                <th>Caregiver</th>
                <th>Ore Effettuate</th>
                <th>Importo Seduta</th>
                <th>Conferma</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let e of pendingEvents" class="table-row">
                <td class="id-cell">
                  <a [href]="'/request-detail/' + e.requestId" target="_blank" class="id-link">#{{ e.requestId }}</a>
                </td>
                <td>{{ e.clientName || '-' }}</td>
                <td *ngIf="showOperatorColumn">{{ e.operator }}</td>
                <td><span class="service-badge">{{ e.service }}</span></td>
                <td>
                  <span class="customer-badge" [ngClass]="e.customerType === 'B2B' ? 'badge-b2b' : 'badge-b2c'">
                    {{ e.customerType }}
                  </span>
                </td>
                <td>{{ e.startDate | date: 'dd/MM/yyyy' }}</td>
                <td>{{ e.endDate | date: 'dd/MM/yyyy' }}</td>
                <td>{{ e.caregiverName || '-' }}</td>
                <td>
                  <input type="number" min="0" class="table-input" [(ngModel)]="e.hoursWorked"
                    [disabled]="confirmingRecordId === e.recordId" />
                </td>
                <td>
                  <input type="number" min="0" step="0.01" class="table-input" [(ngModel)]="e.sessionAmount"
                    [disabled]="confirmingRecordId === e.recordId" />
                </td>
                <td>
                  <button type="button" class="btn-confirm" [disabled]="confirmingRecordId === e.recordId"
                    (click)="confirmEvent(e)">
                    {{ confirmingRecordId === e.recordId ? 'Conferma in corso...' : 'Conferma' }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Da Pagare -->
      <div class="alert-section" *ngIf="toPayEvents.length > 0">
        <div class="section-header status-da-pagare">
          <div class="section-title">
            <i class="bi bi-exclamation-circle-fill"></i>
            <span>Da Pagare</span>
          </div>
          <span class="section-count">
            {{ toPayEvents.length }} {{ toPayEvents.length === 1 ? 'evento' : 'eventi' }}
          </span>
        </div>

        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>ID Richiesta</th>
                <th>Nome Cliente</th>
                <th *ngIf="showOperatorColumn">Operatore</th>
                <th>Servizio</th>
                <th>Tipo Cliente</th>
                <th>Data Inizio</th>
                <th>Data Fine</th>
                <th>Caregiver</th>
                <th>Ore Effettuate</th>
                <th>Importo Seduta</th>
                <th>Link Pagamento</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let e of toPayEvents" class="table-row">
                <td class="id-cell">
                  <a [href]="'/request-detail/' + e.requestId" target="_blank" class="id-link">#{{ e.requestId }}</a>
                </td>
                <td>{{ e.clientName || '-' }}</td>
                <td *ngIf="showOperatorColumn">{{ e.operator }}</td>
                <td><span class="service-badge">{{ e.service }}</span></td>
                <td>
                  <span class="customer-badge" [ngClass]="e.customerType === 'B2B' ? 'badge-b2b' : 'badge-b2c'">
                    {{ e.customerType }}
                  </span>
                </td>
                <td>{{ e.startDate | date: 'dd/MM/yyyy' }}</td>
                <td>{{ e.endDate | date: 'dd/MM/yyyy' }}</td>
                <td>{{ e.caregiverName || '-' }}</td>
                <td>{{ e.hoursWorked }}</td>
                <td>{{ e.sessionAmount | currency: 'EUR' }}</td>
                <td>
                  <button type="button" class="btn-copy" [disabled]="!e.paymentLink"
                    (click)="copyPaymentLink(e.paymentLink)">
                    <i class="bi bi-clipboard"></i> Copia Link
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </ng-container>

  </ng-container>

  <!-- ═══════════════════════ TAB LONGEVITY ═══════════════════════ -->
  <ng-container *ngIf="activeTab === 'longevity'">

    <!-- Admin: no operator selected -->
    <div class="state-message" *ngIf="isAdmin && selectedOperators.length === 0">
      <i class="bi bi-bell" style="font-size: 48px; opacity: 0.2;"></i>
      <p>Seleziona almeno un FamilyTutor per visualizzare i test Longevity.</p>
    </div>

    <!-- FamilyTutor: operator name not found -->
    <div class="state-message" *ngIf="!isAdmin && selectedOperators.length === 0">
      <i class="bi bi-exclamation-triangle" style="font-size: 48px; color: #f59e0b; opacity: 0.5;"></i>
      <p>Impossibile caricare i test Longevity. Rieffettua il login.</p>
    </div>

    <app-longevity-alerts *ngIf="selectedOperators.length > 0" [operators]="longevityOperators"></app-longevity-alerts>

  </ng-container>

</div>
